<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkbtnedit  maintable="STKMA" item="W01" valueExpr="MF002" displayExpr="MF002C" 
 label="股票代號" #MF002Com  id="MF002"  [(value)]="item.MF002" [required]="true"  placeholder="股票代號"  [readonly]="isBrowse"  (valueChange)="srv.MF002Change(item)"     >
    </app-jkbtnedit>
    <app-jknumberedit  label="排序碼" #MF003Com  id="MF003"  [(value)]="item.MF003" placeholder="排序碼"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcheckboxYN  label="更新碼" #MF004Com  id="MF004"  [(valueYN)]="item.MF004"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jktextarea  height="250px" 
 label="備註" #MF005Com  id="MF005"  [(value)]="item.MF005" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkdatefield  label="更新日期" #MF006Com  id="MF006"  [(value)]="item.MF006" placeholder="更新日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>

    </div>
  </div>
</div>